const initialState = {
	global: null,
	ranking: {},
};

const banners = (state = initialState, action) => {
	switch (action.type) {
		case 'FETCH_BILLBOARDS_SUCESS':
			return {
				...state,
				billboards: action.payload,
			};
		case 'FETCH_GLOBAL_BANNERS_SUCESS':
			return {
				...state,
				global: action.payload,
			};
		case 'FETCH_RANKING_BANNERS_SUCESS':
			return {
				...state,
				ranking: {
					...state.ranking,
					[action.payload.id]: action.payload.data,
				},
			};
		case 'RESET_STATE_SUCESS':
			return initialState;
		default:
			return state;
	}
};

export default banners;
